import { SITE_URL } from "@opensea/utils"

const getAuthUrl = (path: string) => {
  if (process.env.AUTH_API_BASE_URL) {
    // if we have access to AUTH_API_BASE_URL, then we're on the server and can call the API directly without FE proxy
    return `${process.env.AUTH_API_BASE_URL}${path.replace("/auth", "")}`
  }

  if (typeof window !== "undefined") {
    return `/__api${path}`
  }

  return `${SITE_URL.origin}/__api${path}`
}

export const authFetch = async (
  path: string,
  init?: RequestInit,
): Promise<Response> => {
  return fetch(getAuthUrl(path), init)
}
